import axios from 'axios';
import { backendRoute } from './route';
import config from '../config';
import { getCsrfToken } from './csrf';
import { isWebviewContext } from './webview';
import { useRelogin } from '../composables/relogin';

export const BACKEND = 'backend';
export const X_ORIGIN_HEADER = 'lokarb-app.http';
export const X_ORIGIN_HEADER_WEBVIEW = 'mobileapp, lokarb-app.http';

// Explicitly set XHR header to mark all requests as XMLHttpRequest
function apiRequiresXhrHeader(api) {
    return [
        BACKEND,
    ].includes(api);
}

// Handle 401 Unauthorized network errors.
export async function interceptorAuthError(error) {
    const relogin = useRelogin();

    const isUnauthorized = error.response?.status === 401;
    const isHeartbeat = error?.response?.config?.baseURL?.includes('oauth/heartbeat');

    if (isUnauthorized) {
        const url = isHeartbeat ?
            backendRoute('backend.authentication.oauthLogin') :
            error?.response?.headers?.['x-location'];

        relogin.requireRelogin({ url });
    }

    return Promise.reject(error);
}

export function xOriginHeaderInterceptor(axiosConfig) {
    if (isWebviewContext()) {
        // eslint-disable-next-line no-param-reassign
        axiosConfig.headers['X-Origin'] = X_ORIGIN_HEADER_WEBVIEW;
    } else {
        // eslint-disable-next-line no-param-reassign
        axiosConfig.headers['X-Origin'] = X_ORIGIN_HEADER;
    }
    return axiosConfig;
}

export function apiEndpoint({
    api,
    endpoint,
    options = {},
    timeout = 60000,
}) {
    const axiosOptions = {
        baseURL: `${config.api[api].url}/${endpoint}`,
        timeout,
        headers: {
            'X-Origin': `${config.xOriginHeader}`,
            'X-CSRF-TOKEN': getCsrfToken(),
        },
        ...options,
    };

    if (apiRequiresXhrHeader(api)) {
        axiosOptions.headers = { ...axiosOptions.headers, 'X-Requested-With': 'XMLHttpRequest' };
    }

    const axiosInstance = axios.create(axiosOptions);

    axiosInstance.interceptors.response.use(response => response, interceptorAuthError);
    axiosInstance.interceptors.request.use(axiosConfig => xOriginHeaderInterceptor(axiosConfig));

    return axiosInstance;
}
